import React from "react";
import "./layout.scss";
import "../../css/style.scss";
import Footer from "../footer/footer";
import Header from "../common/header/header";
import OpenAccountBanner from "../openAccountBanner/openAccountBanner";

const Layout = ({
  isHomePage,
  children,
  articleBanner,
}) => {
  return (
    <div className="container">
      <Header />
      <div
        className="global-wrapper"
        data-is-root-path={isHomePage}
      >
        {articleBanner}
        <div
          className={!isHomePage ? "container-width" : ""}
        >
          <main>{children}</main>
        </div>
      </div>
      <Footer
        showAboutCompany={false}
        showDisclaimer={false}
      />
      <OpenAccountBanner />
    </div>
  );
};

export default Layout;
